export const setBusinessesReducer = (state, action) => {
    state.businesses = action.payload;
};

export const addBusinessReducer = (state, action) => {
    state.businesses[action.payload.id] = action.payload;
};

export const removeBusinessReducer = (state, action) => {
    delete state.businesses[action.payload];
};

export const updateBusinessReducer = (state, action) => {
    const updated = action.payload;
    if (state.businesses[updated.id]) {
        state.businesses[updated.id] = { ...state.businesses[updated.id], ...updated };
    }
};

export const setCurrentBusinessReducer = (state, action) => {
    state.currentBusiness = action.payload;
};
